import { useCreateSlackAndEmailOutboundIntegration } from '@modules/subscribe/hooks/useCreateSlackAndEmailOutboundIntegration';
import { SlackChannelInput } from 'generated/graphql';
import { IntegrationChannelType } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';

export const useCreateSubscription = () => {
  const {
    createOutboundIntegration,
    isLoading: isCreatingOutboundIntegration,
  } = useCreateSlackAndEmailOutboundIntegration();

  const createOutboundIntegrationForType = async (
    channelType: IntegrationChannelType,
    slackChannels: SlackChannelInput[],
    emails: string[],
    outboundIDsToAdd: UUID[],
  ) => {
    const createdOutboundID = await createOutboundIntegration(
      channelType,
      slackChannels,
      emails,
    );

    if (createdOutboundID) {
      outboundIDsToAdd.push(createdOutboundID);
    }
  };

  const createSubscription = async (
    createMutationCallback: (outboundIDs: UUID[]) => Promise<unknown>,
    slackChannels: SlackChannelInput[],
    emails: string[],
  ) => {
    const outboundIDsToAdd: UUID[] = [];

    await Promise.all([
      createOutboundIntegrationForType(
        IntegrationChannelType.Slack,
        slackChannels,
        emails,
        outboundIDsToAdd,
      ),
      createOutboundIntegrationForType(
        IntegrationChannelType.Email,
        slackChannels,
        emails,
        outboundIDsToAdd,
      ),
    ]);

    if (outboundIDsToAdd.length) {
      await createMutationCallback(outboundIDsToAdd);
    }
  };

  return {
    createSubscription,
    isLoading: isCreatingOutboundIntegration,
  };
};
